import React, { lazy } from 'react';

const PlaceOrderComponent = lazy(
  () => import(/* webpackChunkName: "carvana-purchase-place-order" */ './place-order')
);

export const PlaceOrderRoute = () => {
  return <PlaceOrderComponent />;
};
